import { useRecordContext, useResourceContext } from "react-admin";
import * as React from "react";
import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import FirestoreIcon from "@mui/icons-material/LocalFireDepartment";
import { openInFirestoreConsole } from "../firebase";
import { DrivingSchool } from "../providers/drivingSchoolsProvider";
import { Instructor } from "../providers/instructorsProvider";
import { Student } from "../providers/studentsProvider";

const _collectionByResource: { [resource: string]: string } = {
  drivingSchools: "driving_schools",
  instructors: "users",
  students: "users",
};

export function OpenInFirestoreMenuItem({ closeMenu }: { closeMenu: () => void }) {
  const resource = useResourceContext();
  const record = useRecordContext<DrivingSchool | Instructor | Student>();
  const collection = _collectionByResource[resource];
  const path = record ? `${collection}/${record.id}` : collection;
  return (
    <MenuItem
      onClick={() => {
        closeMenu();
        openInFirestoreConsole(path);
      }}
    >
      <ListItemIcon>
        <FirestoreIcon sx={{ fontSize: 20 }} />
      </ListItemIcon>
      <ListItemText>In Firestore öffnen</ListItemText>
    </MenuItem>
  );
}
